const actionScope = '[Ada]';

export class UpdateAdaChatToggleState {
  static readonly type = `${actionScope} Update Ada Chat Toggle State`;

  constructor(public readonly isOpened: boolean) {}
}

export class MarkMessagesAsUnread {
  static readonly type = `${actionScope} Mark Messages As Unread`;
}

export class SetAdaEmbedAsLoaded {
  static readonly type = `${actionScope} Set Ada Embed As Loaded`;
}

export class SetChatAsInitialized {
  static readonly type = `${actionScope} Set Chat As Initialized`;
}

export class ResetConversation {
  static readonly type = `${actionScope} Reset Conversation`;
}
